var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
		'--init-vh': _vm.init_vh,
		'--vh': _vm.vh,
	}),attrs:{"id":"app"}},[(_vm.pages)?_c('header-panel'):_vm._e(),_c('router-view'),(!_vm.mobileMode)?_c('footer-panel',{staticClass:"footer"}):_vm._e(),_c('transition',{attrs:{"name":"preloader-fade"}},[(!_vm.initialized || _vm.loadingStatus.pages || _vm.loadingStatus.language)?_c('preloader',{directives:[{name:"prevent-body-scroll",rawName:"v-prevent-body-scroll"}]}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }